<div class="app-input">
  <mat-label *ngIf="label" class="app-input__label">{{ label }}: </mat-label>
  <mat-form-field appearance="outline">
    <input
      type="text"
      matInput
      matNativeControl
      [formControl]="control"
      [placeholder]="placeholder"
      [name]="name"
      [id]="id"
    />
    @if (!control.value) {
      <mat-icon matSuffix class="def-cursor app-input__icon" svgIcon="search"></mat-icon>
    } @else {
      <mat-icon matSuffix (click)="clear()" class="app-input__icon" svgIcon="close"></mat-icon>
    }
  </mat-form-field>
</div>
